import { decorate, inject, injectable } from 'inversify';
import { SERVICE_IDENTIFIER } from 'constants/identifiers';

@injectable()
class SignalsService {
  constructor(apiService) {
    this.apiService = apiService;
  }

  async getSignalAwaitForInvoice(abortSignal) {
    const result = await this.apiService.get(
      '/signals/awaiting_for_invoice',
      undefined,
      {
        signal: abortSignal,
      },
    );
    return result.data.data.items;
  }
}

decorate(inject(SERVICE_IDENTIFIER.ApiService), SignalsService, 0);

export default SignalsService;
